import { logEvent } from '../../lib/analytics';
import { redirectToOnboardingCheckout } from '../../lib/redirect';
import { BoringAvatar } from '../BoringAvatar';
import { Lock } from '../icons/Lock';

export interface VoicePreviewItem {
  displayName: string;
  image: string;
}

interface BlurredVoicesUnlockProps {
  voiceId: string;
  languageCode: string;
  testVariant: string;
  voicePreviews?: VoicePreviewItem[];
}

export const BlurredVoicesUnlock = ({
  voiceId,
  languageCode,
  testVariant,
  voicePreviews = [],
}: BlurredVoicesUnlockProps) => {
  const handleClick = () => {
    logEvent('more_voices_clicked', {
      current_voice: voiceId,
      language: languageCode,
      test_variant: testVariant,
    });
    redirectToOnboardingCheckout({
      voiceId: voiceId,
      destination: 'voices',
    });
  };

  return (
    <div className="relative z-0 -mx-2 -mb-2 mt-1 min-h-[128px] w-full min-w-[220px] overflow-hidden border border-[#E9EAF0] bg-[#F0F1F5]">
      <div
        className="absolute inset-0 z-[1] flex flex-col gap-1 p-2"
        style={{ filter: 'blur(4px)', pointerEvents: 'none' }}
        aria-hidden>
        {(voicePreviews.length > 0
          ? voicePreviews
          : Array.from({ length: 5 }, () => ({
              displayName: 'Voice',
              image: '',
            }))
        )
          .slice(0, 5)
          .map((voice, i) => (
            <div
              key={i}
              className="flex items-center gap-3 rounded-xl bg-white/80 px-3 py-2 shadow-sm">
              <div className="relative h-8 w-8 shrink-0 overflow-hidden rounded-full bg-[#f0f4f9]">
                {voice.image && voice.image.length > 0 ? (
                  <img
                    src={voice.image}
                    alt={voice.displayName}
                    className="h-full w-full object-cover"
                    width={32}
                    height={32}
                  />
                ) : (
                  <BoringAvatar />
                )}
              </div>
              <span className="truncate text-sm font-medium text-[#1e1a38]">
                {voice.displayName}
              </span>
            </div>
          ))}
      </div>

      <div
        className="absolute inset-0 z-[2] bg-white/40"
        style={{ pointerEvents: 'none' }}
        aria-hidden
      />

      <div className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-1.5 p-3">
        <button
          type="button"
          onClick={handleClick}
          style={{ backgroundImage: 'linear-gradient(to right, #9333ea, #2563eb)' }}
          className="flex w-full max-w-full shrink-0 cursor-pointer items-center justify-center gap-2 rounded-xl border-0 px-2 py-2.5 text-white shadow-[0_2px_8px_rgba(139,92,246,0.35)] outline-none duration-200 hover:opacity-95">
          <Lock className="h-4 w-4 shrink-0 text-white" />
          <span className="truncate text-sm font-semibold">
            Explore 1000+ Voices
          </span>
        </button>
        <span className="text-xs text-[#5c5c6b]">Get access in Studio</span>
      </div>
    </div>
  );
};
